import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./context/AuthContext";
import { MainLayout } from "./components/layout/MainLayout";
import { Dashboard } from "./pages/Dashboard";
import { Login } from "./pages/Login";
import { Settings } from "./pages/Settings";
import { AdminUsers } from "./pages/AdminUsers";
import { Inquiry } from "./pages/Inquiry";
import Users from "./pages/Users";
import { InquiryAdd } from "./pages/InquiryAdd";
import { InquiryEdit } from "./pages/InquiryEdit";
import { InquiryAgentView } from "./pages/InquiryAgentView";
import { InquiryDriverView } from "./pages/InquiryDriverView";
import { InquiryDriverEditView } from "./pages/InquiryDriverEditView";
import { InquiryItineraryView } from "./pages/InquiryItineraryView";
import { InquiryItineraryEditView } from "./pages/InquiryItineraryEditView";
import Tours from "./pages/Tours";
import TourPackage from "./pages/TourPackage";
import TourPackageForm from "./pages/TourPackageForm";
import { Toaster } from "sonner";

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: "/login",
    element: <MainLayout requireAuth={false}><Login /></MainLayout>,
  },
  {
    element: <MainLayout><Outlet /></MainLayout>,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "users",
        element: <Users />,
      },
      {
        path: "tours",
        element: <Tours />,
      },
      {
        path: "tourpackage",
        element: <TourPackage />,
      },
      {
        path: "tourpackage/new",
        element: <TourPackageForm />,
      },
      {
        path: "tourpackage/:id",
        element: <TourPackageForm />,
      },
      {
        path: "inquiry",
        element: <Inquiry />,
      },
      {
        path: "inquiry/add",
        element: <InquiryAdd />,
      },
      {
        path: "inquiry/:id/edit",
        element: <InquiryEdit />,
      },
      {
        path: "inquiry/:id/agent",
        element: <InquiryAgentView />,
      },
      {
        path: "inquiry/:id/driver",
        element: <InquiryDriverView />,
      },
      {
        path: "inquiry-driver-edit/:id",
        element: <InquiryDriverEditView />,
      },
      {
        path: "inquiry/:id/itinerary",
        element: <InquiryItineraryView />,
      },
      {
        path: "inquiry-itinerary-edit/:id",
        element: <InquiryItineraryEditView />,
      },
      {
        path: "settings",
        element: <Settings />,
      },
      {
        path: "admin-users",
        element: <AdminUsers />,
      },
    ],
  },
]);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        <Toaster position="top-right" />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
